// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FVV8u","paragraph":"styles_paragraph__hmGjN"};